
// ProdutoModal.js

import React, { useState, useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext.js';
import './ProdutoModal.css';

function ProdutoModal({ produto, onSave, onClose }) {
  const [id, setId] = useState(produto.id || null);
  const [codpro, setCodpro] = useState(produto.codpro);
  const [produtoNome, setProdutoNome] = useState(produto.produto);
  const [valvenda, setValvenda] = useState(produto.valvenda);
  const { theme } = useTheme();

  // Função para formatar os valores para BRL
  const formatarValorBRL = (valor) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  };

  // Função para lidar com a alteração do valor
  const handleValorChange = (e) => {
    const input = e.target.value;
    const numericValue = parseFloat(input.replace(/[\D]/g, '')) / 100; // Remove caracteres não numéricos e divide por 100
    setValvenda(formatarValorBRL(numericValue)); // Atualiza com o valor formatado
  };

  // useEffect para carregar os dados do produto no modal
  useEffect(() => {
    setId(produto.id || null);
    setCodpro(produto.codpro);
    setProdutoNome(produto.produto);
    setValvenda(formatarValorBRL(produto.valvenda || 0)); // Formata valvenda em BRL ao abrir o modal
  }, [produto]);


  const handleSave = () => {
    // Converte o valor formatado para um número
    let valorNumerico = 0;

    if (typeof valvenda === 'string') {
      valorNumerico = parseFloat(
        valvenda.replace(/[^\d,.-]/g, '').replace(',', '.')
      );
    } else {
      valorNumerico = parseFloat(valvenda);
    }

    const updatedProduto = {
      id,
      codpro,
      produto: produtoNome,
      valvenda: valorNumerico,
    };

    onSave(updatedProduto);
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Produto</h2>
        <form className="form-container">
          <div className="form-group">
            <label>Código</label>
            <input
              type="text"
              value={codpro}
              onChange={(e) => setCodpro(e.target.value)}
              style={{ backgroundColor: theme.fieldBackground, color: theme.color, width: '200px' }}
            />
          </div>
          <div className="form-group">
            <label>Produto</label>
            <input
              type="text"
              value={produtoNome}
              onChange={(e) => setProdutoNome(e.target.value)}
              style={{ backgroundColor: theme.fieldBackground, color: theme.color, width: '300px' }}
            />
          </div>
          <div className="form-group">
            <label>Valor</label>
            <input
              type="text"
              value={valvenda}
              onChange={handleValorChange}
              style={{ backgroundColor: theme.fieldBackground, color: theme.color, width: '200px' }}
            />
          </div>
        </form>
        <div className="modal-actions">
          <button 
            onClick={handleSave} 
            className="btn" 
            style={{ backgroundColor: theme.buttonBackground, padding: '5px 5px', color: theme.buttonText }}
          >
            Salvar
          </button>
          <button 
            onClick={onClose} 
            className="btn" 
            style={{ backgroundColor: theme.buttonBackground, padding: '5px 5px', color: theme.buttonText }}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProdutoModal;